import {
  FETCH_LISTING_START,
  FETCH_LISTING_SUCCESS,
  FETCH_LISTING_FAILURE,
} from '../constants/listingsActionTypes';

const initialState = {
  instance: {},
  isStarted: false,
  isLoad: false,
  isError: false,
  msg: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LISTING_START:
      return {
        ...state,
        isStarted: true,
        isLoad: false,
        isError: false,
        msg: null,
      };
    case FETCH_LISTING_SUCCESS:
      return {
        ...state,
        instance: action.payload,
        isStarted: false,
        isLoad: true,
        isError: false,
      };
    case FETCH_LISTING_FAILURE:
      return {
        ...state,
        instance: {},
        isStarted: false,
        isLoad: true,
        isError: true,
        msg: action.payload,
      };
    default:
      return state;
  }
}

